/* eslint-disable no-unused-vars */
import { axios } from '@/repositories'

const resource = '/v1/stay'
const resource_coupon = '/v1/coupon'

export default {
  async addInListHistory(menuNo, type) {
    // 10170243
    const serviceType = type ? type : 'stay'
    return new Promise((resolve, reject) => {
      const data = {
        itemType: 'viewed',
        menuNo,
        serviceType
      }
      axios
        .post(`${resource}/menu-item-info`, data)
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error?.error)
          }
        )
        .catch(() => {})
    })
  },
  async getPhotoGallery(menuNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/${menuNo}/images`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async getCouponDetail2(acptNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/coupon/${acptNo}`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async getMenuBasicInfo(menuNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/${menuNo}`).then(
        (res) => {
          // resolve(menu)
          resolve(res?.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  async getMenuDetail(menuNo, planId, roomId, companyCd) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}/menu-detail?companyCd=${companyCd}`
        )
        .then(
          (res) => {
            resolve(res?.data)
          },
          (error) => {
            reject(error?.error)
          }
        )
    })
  },
  async getMenuStay(menuNo) {
    return new Promise((resolve, reject) => {
      const params = {}
      axios.get(`${resource}/menu/${menuNo}/stay`, { params }).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  async getRecommendServices(menuNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/menu-list`, { params: { menuNos: menuNo } }).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async getFacilities(params = {}) {
    // facilities/{latitude}/{longitude}?count=xyz&startIndex=xyz
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${resource}/menu/facilities/${params.latitude}/${params.longitude}?count=${
            params.pageSize ? params.pageSize : 10
          }&startIndex=${params.page ? +params.page - 1 : 0}`
        )
        .then(
          (res) => {
            resolve(res.data)
          },
          (error) => {
            // resolve(facilities)
            reject(error?.error)
          }
        )
    })
  },
  // same_category_menus
  async getSameCategoryMenus(queryParams = {}) {
    // facilities/{latitude}/{longitude}?count=xyz&startIndex=xyz
    return new Promise((resolve, reject) => {
      axios
        .get(`${resource}/menu`, {
          params: {
            catLrgClassCd: queryParams.catLrgClassCd ? queryParams.catLrgClassCd : '',
            catMidClassCd: queryParams.catMidClassCd ? queryParams.catMidClassCd : '',
            catSmlClassCd: queryParams.catSmlClassCd ? queryParams.catSmlClassCd : '',
            count: queryParams.pageSize ? queryParams.pageSize : 10,
            startIndex: queryParams.page ? queryParams.page - 1 : 0
          }
        })
        .then(
          (res) => {
            resolve(res.data)
          },
          (error) => {
            reject(error?.error)
          }
        )
    })
  }
}
